const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function getRouteKey() {
  return String(process.env.VUE_APP_ROUTE_ID_KEY || "yandle-bms-route-v1");
}

export function isUuid(value) {
  return UUID_RE.test(String(value ?? "").trim());
}

function toBase64Url(value) {
  const bytes = new TextEncoder().encode(value);
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}

function fromBase64Url(value) {
  const padded = value.replace(/-/g, "+").replace(/_/g, "/");
  const padLength = (4 - (padded.length % 4)) % 4;
  const binary = atob(padded + "=".repeat(padLength));
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

function xorWithKey(value, key) {
  return [...value]
    .map((char, index) =>
      String.fromCharCode(char.charCodeAt(0) ^ key.charCodeAt(index % key.length)),
    )
    .join("");
}

export function encodeRouteOrgId(orgId) {
  const normalized = String(orgId ?? "").trim();
  if (!normalized) return "";
  if (!isUuid(normalized)) return normalized;

  const key = getRouteKey();
  return toBase64Url(xorWithKey(normalized, key));
}

export function decodeRouteOrgId(token) {
  const raw = String(token ?? "").trim();
  if (!raw) return "";
  if (isUuid(raw)) return raw;

  try {
    const decoded = xorWithKey(fromBase64Url(raw), getRouteKey());
    return isUuid(decoded) ? decoded : "";
  } catch {
    return "";
  }
}

export function resolveRouteOrgId(param) {
  const raw = String(param ?? "").trim();
  if (!raw) return "";
  return decodeRouteOrgId(raw) || (isUuid(raw) ? raw : "");
}

export function shouldMaskOrgRouteParam(param) {
  return isUuid(String(param ?? "").trim());
}
